module.exports = __webpack_public_path__ + "static/baked_quiche-51df5c3e69de5fac5422b03516b9c50d.jpg";